import React from 'react';
import MuiPagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GridTableContext } from '../contexts';

export function CustomPagination({
  totalRows,
  pageCount,
  onChange
}: {
  totalRows: number;
  pageCount: number;
  onChange?: (pageIndex: number) => void;
}): JSX.Element {
  const {
    instance: {
      gotoPage,
      state: { pageIndex, pageSize }
    }
  } = React.useContext(GridTableContext);

  const fromRow = pageIndex * pageSize + 1;
  const toRow = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <Stack direction='row' alignItems='center' sx={{ mt: 1 }}>
      {totalRows > 0 && (
        <Typography>
          {fromRow}–{toRow} of {totalRows}
        </Typography>
      )}
      {pageCount > 1 && (
        <MuiPagination
          count={pageCount}
          shape='rounded'
          page={pageIndex + 1}
          onChange={(_: React.ChangeEvent<unknown>, page: number): void => {
            const newPageIndex = page - 1;
            gotoPage(newPageIndex);
            if (onChange) {
              onChange(newPageIndex);
            }
          }}
        />
      )}
    </Stack>
  );
}
